import { useStore } from '@stores';
import { useEffect } from 'react';

/**
 * The tenant's templates for the assign-a-service-to-templates selects.
 * Backed by serviceTemplateStore so the services table and the service drawer share one copy - assigning
 * from either place updates both. Consumers must be mobx observers to see the updates.
 */
export const useServiceTemplateOptions = (enabled: boolean = true) => {
  const { serviceTemplateStore } = useStore();

  useEffect(() => {
    if (!enabled) return;
    serviceTemplateStore.loadLookup();
  }, [enabled, serviceTemplateStore]);

  return {
    loading: !serviceTemplateStore.lookupLoaded,
    templates: serviceTemplateStore.lookup,
    options: serviceTemplateStore.lookup.map((t) => ({ label: t.name, value: t.id })),
    refresh: () => serviceTemplateStore.loadLookup(true),
  };
};
